
import {Link, useParams} from "react-router-dom";

const Breadcrumbs = () => {
    const {id} = useParams()
    let path = ''
    const crumbs = []
    const paths = window.location.pathname.split('/')


    paths.map((item) => {
        path += item == '' ? '' : `/${item}`

        crumbs.push({
            label: item == '' ? 'Home' : item,
            path : path.replace(':id', id)
        })
    })

    let newArr = crumbs.filter(item => item !== null);

    if(
        (paths.includes('journeys') && path.includes('logs')) ||
        (paths.includes('journeys') && path.includes('statistics'))
    ){
        newArr[4] = newArr[3]
        newArr[3] = {label: 'builder', path: `/journeys/${id}/builder`}
    }


    newArr.map((item, index) => {
        const isMongoId = item.label.match(/^[0-9a-fA-F]{24}$/) != null
        if(isMongoId){
            delete newArr[index - 1]
            newArr[index].label = 'edit'
        }
    })


    return (
        <div className="breadcrumbs">
            <ul className="list-inline list-unstyled">
                {newArr.map((item, index) => {
                    return <li className={parseInt(index) + 1 < newArr.length ? 'list-inline-item' : 'list-inline-item last'} key={`breadcrumb_${index}`}>
                        {parseInt(index) + 1 < newArr.length && <Link to={item.path}>{item.label}</Link>}
                        {parseInt(index) + 1 == newArr.length && <span>{item.label}</span>}
                    </li>
                })}
            </ul>
        </div>
    )
}

export default Breadcrumbs;